let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4wdKT")).then(() => parcelRequire('1q9sd'));